import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './authContext';

// Auth-aware entry point used by the "Dashboard" link on the marketing site,
// which doesn't know the signed-in user's customer id up front.
export default function ProductsRedirect() {
  const { user, shopikUser, customer, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;

    if (customer && Object.keys(customer).length > 0) {
      navigate('/products-v2/' + user?.uid, { replace: true });
    } else if (shopikUser && Object.keys(shopikUser).length > 0) {
      navigate('/customer-select', { replace: true });
    }
  }, [loading, user, shopikUser, customer, navigate]);

  return null;
}
